module.exports = __webpack_public_path__ + "398ff6d54edc1d484f974eed25578492.svg";